export const Images = {
  whatsapp: require('../assets/Images/whatsapp.png'),
  eye: require('../assets/Icons/Camada_1.png'),
  closedEye: require('../assets/Icons/Camada_2.png'),
  ProfileSimbol: require('../assets/Icons/logo_brasal.png'),
  backgroundCoke: require('../assets/Images/backgroundCoke.png'),
  check: require('../assets/Icons/Check.png'),
  user: require('../assets/Icons/user.png'),
  bag: require('../assets/Icons/bag.png'),
  cart: require('../assets/Icons/caminhao.png'),
  bell: require('../assets/Icons/bell.png'),
  glass: require('../assets/Icons/glass.png'),
  promotion: require('../assets/Images/promotion.png'),
  cokeLogo: require('../assets/Images/CokeLogo.png'),
  heineken: require('../assets/Images/heineken.png'),
  guaranaJ: require('../assets/Images/guaranaJ.png'),
  filterIcon: require('../assets/Icons/filterIcon.png'),
  soda: require('../assets/Images/soda.png'),
  hydration: require('../assets/Images/hydration.png'),
  beer: require('../assets/Images/beer.png'),
  noAlcohol: require('../assets/Images/noAlcohol.png'),
  FiltersIcon: require('../assets/Icons/FiltersIcon.png'),
  guaranaJImage: require('../assets/Images/guaranaJImage.png'),
  homeIcon: require('../assets/Icons/homeIcon.png'),
  bottle: require('../assets/Icons/bottle.png'),
  biggerGlass: require('../assets/Images/biggerGlass.png'),
  warning: require('../assets/Images/warning.png'),
  houseP: require('../assets/Icons/houseP.png'),
  bottleP: require('../assets/Icons/bottleP.png'),
  heart: require('../assets/Icons/heart.png'),
  bagImage: require('../assets/Images/bag.png'),
  warningB: require('../assets/Images/warningB.png'),
  card: require('../assets/Icons/card.png'),
  cardP: require('../assets/Icons/cardP.png'),
  campaigns: require('../assets/Icons/campaigns.png'),
  cocazero: require('../assets/Images/cocazero.png'),
  fantacocacom: require('../assets/Images/fantacocacom.png'),
  cocaocean: require('../assets/Images/cocaocean.png'),
  heinekenrio: require('../assets/Images/heinekenrio.png'),
  coffecoca: require('../assets/Images/coffecoca.png'),
  fabric: require('../assets/Icons/fabric.png'),
  product: require('../assets/Icons/product.png'),
  doubt: require('../assets/Icons/doubt.png'),
  tool: require('../assets/Icons/tool.png'),
  gear: require('../assets/Icons/gear.png'),
  equipamentIcon: require('../assets/Icons/equipamentIcon.png'),
  checkToast: require('../assets/Icons/checkToast.png'),
  guaranaJMini: require('../assets/Images/guaranaJMini.png'),
  bear: require('../assets/Images/bear.png'),
  emptyImage: require('../assets/Images/emptyImage.png'),
  emptyImgIcon: require('../assets/Icons/emptyImgIcon.png'),
  cokeFreeze: require('../assets/Images/cokeFreeze.jpeg'),
  truckIcon: require('../assets/Icons/truck.png'),
  bottleLoading: require('../assets/Icons/bottleLoading.png'),
  exchangeIcon: require('../assets/Icons/exchangeIcon.png'),
  saleIcon: require('../assets/Icons/sale-icon.png'),
  hourGlassIcon: require('../assets/Icons/hourglass.png'),
  documentIcon: require('../assets/Icons/document.png'),
  masterCardIcon: require('../assets/Icons/mc_symbol.png'),
  visaIcon: require('../assets/Icons/visa-logo.webp'),
  pixIcon: require('../assets/Icons/pix-logo.png'),
  boletoIcon: require('../assets/Icons/barras.png'),
  heartIcon: require('../assets/Icons/heart_icon.png'),
  favorite: require('../assets/Images/favoriteButton.png'),
  notFavorite: require('../assets/Images/notFavoriteButton.png'),
  logoRefri: require('../assets/Images/logo-refri.png'),
};
